

/**
*	Adds an event handler that runs when the element is clicked.
	[Read more](https://www.wix.com/corvid/reference/$w.ClickableMixin.html#onClick)
*	 @param {$w.MouseEvent} event
*/
import wixLocation from 'wix-location';
const ButtonId = '#whatsappsend'; // ID DO BOTÃO NO PROJETO HTML
const WhatsappNumber = '557191770157'; // NÚMERO DE TELEFONE
const PreMsg = 'Olá, tenho interesse neste produto: '; // MENSAGEM PERSONALIZADA

export function whatsappSend() {
  const url = wixLocation.url;
  const ref = `https://api.whatsapp.com/send?phone=${WhatsappNumber}&text=${PreMsg}${url}`;
  wixLocation.to(ref);
}

$w.onReady(function () {
  const button = $w(ButtonId);
  button.onClick(whatsappSend);
});
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
